import { EMPTY_STRING } from '../../../../constants/common'
import { REG_EXP_EMAIL } from '../../../../constants/regExp'
import { toUserSelectItems } from '../../../User'

import {
  REQUEST_PROFILE_WIDGET_SIDE_WORKERS_FIELD_NAME_COMMENT,
  REQUEST_PROFILE_WIDGET_SIDE_WORKERS_FIELD_NAME_HAS_INVALID_INPUT,
  REQUEST_PROFILE_WIDGET_SIDE_WORKERS_FIELD_NAME_IS_INVITATION,
  REQUEST_PROFILE_WIDGET_SIDE_WORKERS_FIELD_NAME_SIDE_WORKERS,
} from './RequestProfileWidgetSideWorkers.constants'

export function getRequestProfileWidgetSideWorkersInitialValues(sideWorkers) {
  return {
    [REQUEST_PROFILE_WIDGET_SIDE_WORKERS_FIELD_NAME_COMMENT]: EMPTY_STRING,
    [REQUEST_PROFILE_WIDGET_SIDE_WORKERS_FIELD_NAME_HAS_INVALID_INPUT]: false,
    [REQUEST_PROFILE_WIDGET_SIDE_WORKERS_FIELD_NAME_IS_INVITATION]: false,
    [REQUEST_PROFILE_WIDGET_SIDE_WORKERS_FIELD_NAME_SIDE_WORKERS]:
      toUserSelectItems(sideWorkers),
  }
}

export function getRequestProfileWidgetSideWorkersPayload(values) {
  const sideWorkers =
    values[REQUEST_PROFILE_WIDGET_SIDE_WORKERS_FIELD_NAME_SIDE_WORKERS]

  const workersPayload = {
    new_worker_emails: sideWorkers
      .filter(
        item =>
          item.isNewWorkerEmail &&
          Boolean(item.email) &&
          REG_EXP_EMAIL.test(item.email)
      )
      .map(item => item.email),
    worker_ids: sideWorkers
      .filter(item => !item.isNewWorkerEmail && Boolean(item.value))
      .map(item => item.value),
  }

  if (values[REQUEST_PROFILE_WIDGET_SIDE_WORKERS_FIELD_NAME_IS_INVITATION]) {
    workersPayload.comment =
      values[REQUEST_PROFILE_WIDGET_SIDE_WORKERS_FIELD_NAME_COMMENT] ?? null
  }

  return { workers: workersPayload }
}
